import RangeDatePicker from './RangeDatePicker';
import './RangeDatePicker.scss';

export default RangeDatePicker;
